/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smartlab_Settings_Machine_Card_DescInputs */

const vi_smartlab_settings_machine_card_desc = /** @type {(inputs: Smartlab_Settings_Machine_Card_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản đọc trạng thái và điều khiển máy vò chè.`)
};

/**

* @param {Smartlab_Settings_Machine_Card_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const smartlab_settings_machine_card_desc = /** @type {((inputs?: Smartlab_Settings_Machine_Card_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smartlab_Settings_Machine_Card_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_smartlab_settings_machine_card_desc(inputs)
});